/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { IncidentTypeDto } from './incidentTypeDto.schema';

export const IReadOnlyListOfIncidentTypeDto = zod.array(zod.lazy(() => IncidentTypeDto));

export type IReadOnlyListOfIncidentTypeDto = zod.input<typeof IReadOnlyListOfIncidentTypeDto>;
export type IReadOnlyListOfIncidentTypeDtoOutput = zod.output<typeof IReadOnlyListOfIncidentTypeDto>;
